/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ format: NonNullable<unknown>, path: NonNullable<unknown> }} Drastic_Tech_File_Created_LogInputs */



/**
* | output |
* | --- |
* | "{format} file created at {path}" |
*
* @param {Drastic_Tech_File_Created_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_file_created_log = /** @type {((inputs: Drastic_Tech_File_Created_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_File_Created_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Fichier ${i?.format} cree a ${i?.path}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.format}-Datei erstellt in ${i?.path}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`File ${i?.format} creato in ${i?.path}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Файл ${i?.format} создан в ${i?.path}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Archivo ${i?.format} creado a las ${i?.path}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.format} 文件创建于 ${i?.path}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.format} ファイルが ${i?.path} に作成されました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.format} फ़ाइल ${i?.path} पर बनाई गई`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Arquivo ${i?.format} criado em ${i?.path}`)
	return /** @type {LocalizedString} */ (`${i?.format} file created at ${i?.path}`)
});